import { useMemo } from 'react';

const useInitials = (str) => {
  return useMemo(() => {
    if (!str) return '';
    const intials = str
      .split(' ')
      .map((word) => word[0] ?? '')
      .join('')
      .substring(0, 3);
    return intials;
  }, [str]);
};

export default useInitials;
